module.exports = __webpack_public_path__ + "static/media/feat-underground-img1.b8df4f02.jpg";